import BaseService from "service/base.js";

class ContentGroupService {
  load() {
    return BaseService.get("/api/content-groups");
  }

  new(name, contents) {
    return BaseService.post("/api/content-group", { contents, name });
  }

  edit(id, name, contents) {
    return BaseService.put(`/api/content-group/${id}`, { contents, name });
  }
}

const contentGroupService = new ContentGroupService();
export default contentGroupService;
export { contentGroupService };
